const NON_TEXT_INPUT_TYPES = new Set(['checkbox', 'radio', 'button', 'submit', 'reset', 'file', 'range', 'color', 'image']);

export function isTextFieldActive(element: Element | null): boolean {
  if (!element) return false;
  if (element.tagName === 'TEXTAREA') return true;
  if (element.tagName === 'INPUT') {
    return !NON_TEXT_INPUT_TYPES.has(((element as HTMLInputElement).type || 'text').toLowerCase());
  }
  return (element as HTMLElement).isContentEditable === true;
}

// The collapsed assistant is the one overlay that still lets the canvas have it.
export function canvasOwnsSelectAll(element: Element | null): boolean {
  if (!element?.closest('.cdk-overlay-container')) return true;
  return element.closest('app-chat-bottomsheet')?.classList.contains('collapsed') === true;
}
